/*
 eslint-disable global-require, no-unused-vars
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { render } from 'react-dom';
import { compose, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import rootReducer from './reducers/index';
import App from './containers/App';
import fetchActiveCommunityUserCount from './actions/action-community-online';
import getLocale from './actions/action-locale';
import { getHelpCenterAlerts } from './actions/index';
import { requestMetadata } from '../lib/griffin-metadata';

import fetchContactUsOnLogin from './actions/action-contact-us';
import { locationChecker } from './actions/action-contact-location';
import getPopularQuestions from '../home/actions/action-popular-list';
import Page from '../lib/page';
import { isNaaAlertEnabledInRC, validateAMFlag } from '../lib/globalHelper';
import { fetchPhoneNumber } from './actions/action-call-us';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
/* eslint-disable global-require,  import/no-extraneous-dependencies */
  const defaultLogger = require('redux-logger');

  middlewares.push(defaultLogger.createLogger());
/* eslint-enable global-require,  import/no-extraneous-dependencies */
}

const store = createStore(rootReducer,
  undefined,
  compose(
    autoRehydrate(),
    applyMiddleware(...middlewares),
  ));

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: ['modal', 'persistEmailForm', 'user', 'breadCrumb', 'smcResultKeeper', 'persistLocation', 'persistedStepUp'],
}, () => {
  store.dispatch(getLocale());
  // Check Page path for loading data
  store.dispatch(locationChecker());
  store.dispatch(fetchContactUsOnLogin());
});

store.dispatch(fetchActiveCommunityUserCount());
store.dispatch(getHelpCenterAlerts());

// For logged in customers get BNA articles to check if any NAA restriction exists
if (Page.isLoggedIn() && isNaaAlertEnabledInRC()) {
  store.dispatch(getPopularQuestions(Page.getUserExperience(), 'contactUs'));
}

// Dispatching callus API on page load to enable callus option
// if customer has am flag
if (validateAMFlag()) {
  store.dispatch(fetchPhoneNumber());
}

const contactUsApp = () => render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);

requestMetadata().then(contactUsApp).catch(contactUsApp);
